import classNames from "classnames";
import { usePopup } from "../../../components/popup/popup";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { Input } from "../../../components/input/input";
import { Button } from "../../../components/button/button";
import { ArrowIcon, FindItemIcon } from "../../../assets/icons";
import { TextInput } from "../../../components/textInput/textInput";
import { useState } from "react";
import { ProfileInfo } from "../../../components/profileInfo/profileInfo";
import { Checkbox } from "../../../components/checkbox/checkbox";

import styles from "./addWorkerShiftPage.module.css";

import { Text } from "../../../components/text/text";

const getEmployeesText = (n) => {
    if (n % 10 === 1 && n % 100 !== 11) return `Выбран ${n} сотрудник`;
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return `Выбрано ${n} сотрудника`;
    return `Выбрано ${n} сотрудников`;
}

export const InputBlock = ({ type, title, values, value, setValue, multiple = false, className, min, max, error }) => {
    const [Popup, open, close] = usePopup();

    const [search, setSearch] = useState("");

    const normalizedValues = Array.isArray(values) ? values : [];
    const selectedList = multiple ? (Array.isArray(value) ? value : []) : [];

    return (
        <div className={classNames(styles.input_block, className)}>
            <Text as="div" variant="caption" className={styles.input_block_title} size={14}>
                {title}
            </Text>
            {type === "number" && <NumberInput error={error} val={value} setVal={setValue} min={min} max={max} />}
            {type !== "number" && type !== "user" && <Input error={error} type={type} value={value} setValue={setValue} />}
            {
                type === "user" &&
                <>
                    {!multiple && (
                        <>
                            {!!value && (
                                <Button
                                    text={<ProfileInfo name={value.name} photo={value.photo} />}
                                    type="hint"
                                    icon={<ArrowIcon />}
                                    onClick={open}
                                />
                            )}

                            {!value && (
                                <Button
                                    text="Пользователь не выбран"
                                    type="hint"
                                    icon={<ArrowIcon />}
                                    onClick={open}
                                />
                            )}

                            <Popup>
                                <Text as="div" variant="h1" className={styles.title} >
                                    Выбрать сотрудника
                                </Text>

                                <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

                                <div className={styles.users_list}>
                                    {normalizedValues
                                        .filter(el => el.name.toLowerCase().includes(search.toLowerCase().trim()))
                                        .map(data => (
                                            <Button
                                                key={data.userId}
                                                text={<ProfileInfo name={data.name} photo={data.photo} />}
                                                type="hint"
                                                icon={<ArrowIcon />}
                                                onClick={() => {
                                                    setValue(data);
                                                    close();
                                                }}
                                            />
                                        ))}
                                </div>
                            </Popup>
                        </>
                    )}

                    {multiple && (
                        <>
                            {selectedList.length > 0 && (
                                <Button
                                    text={<ProfileInfo name={selectedList.length > 1 ? getEmployeesText(selectedList.length) : selectedList[0].name} photo={selectedList[0].photo} />}
                                    type="hint"
                                    icon={<ArrowIcon />}
                                    onClick={open}
                                />
                            )}

                            {selectedList.length === 0 && (
                                <Button
                                    text="Пользователи не выбраны"
                                    type="hint"
                                    icon={<ArrowIcon />}
                                    onClick={open}
                                />
                            )}

                            <Popup>
                                <Text as="div" variant="h1" className={styles.title} >
                                    Выбрать сотрудников
                                </Text>

                                <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

                                <div className={styles.users_list}>
                                    {normalizedValues
                                        .filter(el => el.name.toLowerCase().includes(search.toLowerCase().trim()))
                                        .map(data => (
                                            <Button
                                                key={data.userId}
                                                text={<ProfileInfo name={data.name} photo={data.photo} />}
                                                type="hint"
                                                icon={
                                                    <Checkbox
                                                        className={styles.checkbox}
                                                        checked={selectedList.findIndex(el => el.userId === data.userId) !== -1}
                                                        onChange={() => { }}
                                                    />
                                                }
                                                onClick={() => {
                                                    if (selectedList.findIndex(el => el.userId === data.userId) !== -1) {
                                                        setValue(prev => prev.filter(el => el.userId !== data.userId));
                                                    } else {
                                                        setValue(prev => [...prev, data]);
                                                    }
                                                }}
                                            />
                                        ))}
                                </div>

                                <Button
                                    text="Сохранить"
                                    onClick={close}
                                />
                            </Popup>
                        </>
                    )}
                </>
            }
        </div>
    )
}
